export const CALCULATION_START_YEAR_LIMIT = '2018'
